import React from 'react'
import { InputGroup, DropdownButton, Dropdown, Form } from 'react-bootstrap'
import AddButton from './add-button'
import useSearchFilter from './use-search-filter'
import SearchButton from './search-button'

const SearchFilter = ({
    title,
    value = '',
    onChange = () => {},
    disabled,
    size,
    addButton = false,
}) => {
    const { search, setSearch, onSearchClick, canSearch } = useSearchFilter({ value, onChange })
    const iconSize = size === 'lg' ? 18 : 12

    return (
        <InputGroup>
            <Form.Control placeholder={title} value={search} onChange={e => setSearch(e.target.value)}  disabled={disabled} size={size} />
            <InputGroup.Append>
                <SearchButton onClick={onSearchClick} hasValue={canSearch} disabled={disabled} />
                <AddButton visible={addButton} />
            </InputGroup.Append>

        </InputGroup>
    )
}

export default SearchFilter